import React from "react";

// Shared logo: dark slate tile with gold serif "L" + Lawfields wordmark with
// gold-dashed SOLICITORS subtext. Tile and wordmark share equal height so
// the wordmark stack stays visually contained within the tile bounds.
//
// `size` controls the tile height (square). Wordmark + L letter scale proportionally.
export const Logo = ({ size = 56, showWordmark = true, className = "" }) => {
  const tile = size;
  const letterSize = Math.round(size * 0.6);
  const nameSize = Math.round(size * 0.39);
  const subSize = Math.max(9, Math.round(size * 0.18));
  const dashWidth = Math.round(size * 0.25);
  const gap = Math.round(size * 0.18);

  return (
    <div
      className={`inline-flex items-stretch gap-3 ${className}`}
      style={{ height: tile }}
    >
      <div
        className="flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-[#22222B] to-[#15151D] border border-white/5"
        style={{
          width: tile,
          height: tile,
          boxShadow:
            "inset 0 1px 0 rgba(255,255,255,0.06), 0 6px 14px rgba(0,0,0,0.45)",
        }}
        aria-hidden
      >
        <span
          className="font-serif text-[#E9C76A] leading-none"
          style={{
            fontSize: letterSize,
            textShadow: "0 0 18px rgba(233,199,106,0.30)",
            transform: "translateY(-3px)",
          }}
        >
          L
        </span>
      </div>
      {showWordmark && (
        <div
          className="flex flex-col justify-center leading-none"
          style={{ gap }}
        >
          <span
            className="font-serif text-[#F5F2E8] tracking-tight leading-none"
            style={{ fontSize: nameSize }}
          >
            Lawfields
          </span>
          <span
            className="flex items-center text-[#E9C76A] uppercase font-sans leading-none"
            style={{
              fontSize: subSize,
              letterSpacing: "0.32em",
              gap: 8,
            }}
          >
            <span
              className="bg-[#E9C76A]"
              style={{ width: dashWidth, height: 1, opacity: 0.95 }}
              aria-hidden
            />
            Solicitors
            <span
              className="bg-[#E9C76A]"
              style={{ width: dashWidth, height: 1, opacity: 0.95 }}
              aria-hidden
            />
          </span>
        </div>
      )}
    </div>
  );
};
